import React, { useState } from "react";
import { AuthChecker } from "../atomicComponents";

export default function FooterButton(props) {
    const [bgColour, setBgColour] = useState(props.backgroundColor);
    return (
        <>
            {
                props.shouldEnable ?
                    <button
                        id={props.value}
                        onMouseEnter={(e) =>
                            !e.target.disabled ? setBgColour(props.secondaryColor) : null
                        }
                        onMouseLeave={() => setBgColour(props.backgroundColor)}
                        className="footer-button regularFont"
                        style={{ backgroundColor: bgColour, color: props.color }}
                        onClick={() => props.handle(props.value)}
                    >
                        {props.value.replace(/-/g, " ")}
                    </button> :
                    <AuthChecker operation={props.authOperation}>
                        {(isAuthorized) => (
                            <button
                                id={props.value}
                                onMouseEnter={(e) =>
                                    !e.target.disabled ? setBgColour(props.secondaryColor) : null
                                }
                                onMouseLeave={() => setBgColour(props.backgroundColor)}
                                className="footer-button regularFont"
                                style={{ backgroundColor: !isAuthorized ? "#d8d8d8 " : bgColour, color: !isAuthorized ? "#707070 " : props.color, cursor: !isAuthorized ? 'default' : 'pointer' }}
                                onClick={() => props.handle(props.value)}
                                disabled={!isAuthorized}
                            >
                                {props.value.replace(/-/g, " ")}
                            </button>
                        )}
                    </AuthChecker>
            }
            <style jsx="true">
                {`
                    .footer-button {
                        align-items: center;
                        border: none;
                        border-radius: 4px;
                        box-shadow: 0 3px 3px rgb(0 0 67 / 13%);
                        color: #fff;
                        cursor: pointer;
                        display: flex;
                        font-weight: 700;
                        line-height: 19px;
                        padding: 0.5rem 2rem;
                        text-align: center;
                        text-transform: uppercase;
                        white-space: nowrap;
                    }
                `}
            </style>
        </>
    );
}
